import { collection, getDocs } from 'firebase/firestore';

import { db } from '../config';
import { useLangState } from './useLangState';

interface Language {
    code: string;
    name: string;
}

export const fetchLanguages = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, 'languages'));
    const languages: Language[] = [];

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      if (data?.code && data?.name) {
        languages.push({ code: data.code, name: data.name });
      }
    });

    const languageCodes = languages.map((lang) => lang.code);
    useLangState.getState().setLanguages(languageCodes);
  } catch (error) {
    console.error('Error fetching languages:', error);
  }
};
